import React, { useState, useEffect, useRef } from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Dialog as DialogPrime } from 'primereact/dialog';
import { Button } from '@material-ui/core';

import IconeLeito from '../../assets/img/IconesMapaLeito/Leito.png';
import IconeExtra from '../../assets/img/IconesMapaLeito/LeitoExtra.png';
import IconeExtraCross from '../../assets/img/IconesMapaLeito/LeitoExtraCross.png';
import IconeBercoNormal from '../../assets/img/IconesMapaLeito/BercoNormal.png';
import IconeBercoExtra from '../../assets/img/IconesMapaLeito/BercoExtra.png';
import IconeBercoRegulado from '../../assets/img/IconesMapaLeito/BercoRegulado.png';
import IconeRegulado from '../../assets/img/IconesMapaLeito/ReguladoNIR.png';
import IconeBloqueado from '../../assets/img/IconesMapaLeito/LeitoBloqueado.png';
import IconeBloqueadoExtra from '../../assets/img/IconesMapaLeito/LeitoBloqueadoExtra.png';

import IconeVerde from '../../assets/img/IconesMapaLeito/Verde.png';
import IconeVermelho from '../../assets/img/IconesMapaLeito/Vermelho.png';
import IconeLaranja from '../../assets/img/IconesMapaLeito/Laranja.png';
import IconeRoxo from '../../assets/img/IconesMapaLeito/Roxo.png';
import IconeLeito2 from '../../assets/img/IconesMapaLeito/Leito2.png';
import IconeLeitoR from '../../assets/img/IconesMapaLeito/LeitoR.png';
import IconeLeitoExtraCross from '../../assets/img/IconesMapaLeito/LeitoExtraCross2.png';
import IconeLeitoExtraNaoCross from '../../assets/img/IconesMapaLeito/LeitoExtra2.png';
import IconeBerco from '../../assets/img/IconesMapaLeito/Berco.png';
import IconeBercoR from '../../assets/img/IconesMapaLeito/BercoR.png';
import IconeBercoE from '../../assets/img/IconesMapaLeito/BercoE.png';
import IconeLeitoBloqueado from '../../assets/img/IconesMapaLeito/Bloqueado.png';
import IconeBloqueadoE from '../../assets/img/IconesMapaLeito/BloqueadoE.png';

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import DetalhesInternacao from './DetalhesInternacao';

import { dominioLeanAspNetAPI } from '../../config/database';

export default function MapaLeito() {
  const listaUnidadeTecnica = [
    {
      id: 1,
      nome: 'HC I',
    },
    {
      id: 2,
      nome: 'HC II',
    },
  ];
  const [unidadeTecnicaSelecionadaId, setUnidadeTecnicaSelecionadaId] = useState(
    listaUnidadeTecnica[0].id
  );
  const [listaAlas, setListaAlas] = useState([]);
  const [abreDetalhesInternacao, setAbreDetalhesInternacao] = useState(false);
  const [leitoSelecionado, setLeitoSelecionado] = useState(null);
  const [alaSelecionada, setAlaSelecionada] = useState(null);
  const [carregar, setCarregar] = useState(false);
  const [alaOpen, setAlaOpen] = useState(null);
  const [profissional, setProfissional] = useState(
    JSON.parse(localStorage.getItem('profissional'))
  );
  const [abreAviso, setAbreAviso] = useState(false);

  const getListaAlas = (unidadeTecnicaId, carrega) => {
    const filtroAlas = {
      seqUnidadeTecnica: unidadeTecnicaId,
    };

    if (carrega) {
      setCarregar(true);
    }

    dominioLeanAspNetAPI
      .post(`/api/listarAlas`, filtroAlas)
      .then(response => {
        const alasOrdenadas = response.data.map(ala => {
          const quartosOrdenados = [...ala.quartos].sort((a, b) => {
            const menorA = Math.min(...a.leitos.map(l => Number(l.numero)));
            const menorB = Math.min(...b.leitos.map(l => Number(l.numero)));
            return menorA - menorB;
          });

          return {
            ...ala,
            quartos: quartosOrdenados,
          };
        });

        setListaAlas(alasOrdenadas);
      })
      .finally(() => {
        setCarregar(false);
      });
  };

  useEffect(() => {
    getListaAlas(unidadeTecnicaSelecionadaId, true);
  }, [unidadeTecnicaSelecionadaId]);

  const alteraUnidadeTecnica = event => {
    setUnidadeTecnicaSelecionadaId(event.target.value);
    getListaAlas(event.target.value, true);
  };

  const handleClickLeito = (leito, ala) => {
    if (leito.situacao === 'Bloqueado' && leito.cor === '#BD1711') return;

    setLeitoSelecionado(leito);
    setAlaSelecionada(ala);
    if (leito.cor === '#059E14' && !profissional.permissaoNIR) {
      setAbreAviso(true);
    } else {
      setAbreDetalhesInternacao(true);
    }
  };

  const handleIconeLeito = situacao => {
    switch (situacao) {
      case 'Regulado':
        return IconeRegulado;
      case 'ReguladoRN':
        return IconeBercoRegulado;
      case 'LeitoRN':
        return IconeBercoNormal;
      case 'ExtraCross':
        return IconeExtraCross;
      case 'ExtraRN':
        return IconeBercoExtra;
      case 'Extra':
        return IconeExtra;
      case 'BloqueadoExtra':
        return IconeBloqueadoExtra;
      case 'Bloqueado':
        return IconeBloqueado;
      default:
        return IconeLeito;
    }
  };

  const renderQuarto = (ala, quarto) => {
    if (quarto.leitos.sort((a, b) => a.numero - b.numero).length <= 12)
      return (
        <>
          {quarto.leitos.map(leito => (
            <IconButton
              key={leito.seqLeito}
              style={{
                backgroundColor: leito.cor,
                borderRadius: 10,
                color: '#FFFFFF',
                width: '4vw',
                height: '4vw',
                paddingTop: '3px',
                alignItems: 'end',
                boxShadow: '2px 2px #000000',
                padding: '0.5vw',
              }}
              onClick={() => handleClickLeito(leito, ala)}
            >
              <div
                style={{
                  display: 'block',
                }}
              >
                <div
                  style={{
                    marginBottom: '0.5vw',
                    position: 'absolute',
                    top: -7,
                    margin: 'auto',
                    backgroundColor: leito.cor,
                    boxShadow: '1.5px 1.5px #000000',
                    width: '2.75vw',
                    borderRadius: 3,
                    left: '0.625vw',
                    fontSize: '1.1vw',
                    fontWeight: 'bold',
                  }}
                >
                  {leito.numero}
                </div>
                <Box
                  component="img"
                  src={handleIconeLeito(leito.situacao)}
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: '3.1vw',
                    margin: 'auto',
                    width: '2.75vw',
                    left: '0.625vw',
                    fontSize: '0.65vw',
                    fontWeight: 'bold',
                    visibility: leito.gmr ? 'show' : 'hidden',
                  }}
                >
                  GMR
                </div>
              </div>
            </IconButton>
          ))}
        </>
      );

    return (
      <Grid container spacing={2}>
        {quarto.leitos.map(leito => (
          <Grid
            key={leito.seqLeito}
            item
            xs={quarto.leitos.length / 12}
            sm={quarto.leitos.length / 12}
          >
            <IconButton
              key={leito.seqLeito}
              style={{
                backgroundColor: leito.cor,
                borderRadius: 10,
                color: '#FFFFFF',
                width: '4vw',
                height: '4vw',
                paddingTop: '3px',
                alignItems: 'end',
                boxShadow: '2px 2px #000000',
                padding: '0.5vw',
              }}
              onClick={() => handleClickLeito(leito, ala)}
            >
              <div
                style={{
                  display: 'block',
                }}
              >
                <div
                  style={{
                    marginBottom: '0.5vw',
                    position: 'absolute',
                    top: -7,
                    margin: 'auto',
                    backgroundColor: leito.cor,
                    boxShadow: '1.5px 1.5px #000000',
                    width: '2.75vw',
                    borderRadius: 3,
                    left: '0.625vw',
                    fontSize: '1.1vw',
                    fontWeight: 'bold',
                  }}
                >
                  {leito.numero}
                </div>
                <Box
                  component="img"
                  src={handleIconeLeito(leito.situacao)}
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                />
              </div>
            </IconButton>
          </Grid>
        ))}
      </Grid>
    );
  };

  const handleAccordionChange = nomeAla => {
    setAlaOpen(prev => (prev === nomeAla ? null : nomeAla));
  };

  const fechaDetalhesInternacao = carrega => {
    setAbreDetalhesInternacao(false);
    if (carrega) {
      getListaAlas(unidadeTecnicaSelecionadaId, carrega);
    }
  };

  const refsAlas = useRef({});

  listaAlas.forEach(ala => {
    if (!refsAlas.current[ala.nome]) {
      refsAlas.current[ala.nome] = React.createRef();
    }
  });

  useEffect(() => {
    if (alaOpen && refsAlas.current[alaOpen]) {
      setTimeout(() => {
        const element = refsAlas.current[alaOpen]?.current;
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      }, 300);
    }
  }, [listaAlas]);

  if (carregar) {
    return <ProgressSpinner style={{ left: '45%' }} />;
  }

  return (
    <>
      <DialogPrime
        header="Detalhes da Internação"
        visible={abreDetalhesInternacao}
        style={{ width: '65vw' }}
        onHide={() => fechaDetalhesInternacao(false)}
      >
        <DetalhesInternacao
          leito={leitoSelecionado}
          ala={alaSelecionada}
          fechaDetalhesInternacao={fechaDetalhesInternacao}
        />
      </DialogPrime>
      <DialogPrime
        header="Atenção!"
        visible={abreAviso}
        style={{ width: '65vw' }}
        onHide={() => setAbreAviso(false)}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Typography>Não há internação para esse leito.</Typography>
          </Grid>
          <Grid item xs={3} sm={3}>
            <Button onClick={() => setAbreAviso(false)}>Voltar</Button>
          </Grid>
        </Grid>
      </DialogPrime>

      <Grid
        container
        xs={12}
        justifyContent="center"
        alignItems="center"
        direction="row"
        style={{ marginTop: -30, marginBottom: 30 }}
      >
        <Grid item>
          <Grid container direction="column" alignItems="center">
            <img src={IconeVerde} alt="Verde" style={{ width: 40, height: 40 }} />
            <Typography className="legenda">Liberado</Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="column" alignItems="center">
            <img src={IconeVermelho} alt="Vermelho" style={{ width: 40, height: 40 }} />
            <Typography className="legenda">Ocupado</Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="column" alignItems="center">
            <img src={IconeLaranja} alt="Laranja" style={{ width: 40, height: 40 }} />
            <Typography className="legenda">Alta</Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="column" alignItems="center">
            <img src={IconeRoxo} alt="Roxo" style={{ width: 40, height: 40 }} />
            <Typography className="legenda">Higiene</Typography>
          </Grid>
        </Grid>

        <Grid item>
          <Grid container direction="column" alignItems="center">
            <img src={IconeLeito2} alt="Ícone leito" style={{ width: 50, height: 30 }} />
            <Typography className="legenda">Leito</Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="column" alignItems="center">
            <img src={IconeLeitoR} alt="Ícone Regulado" style={{ width: 50, height: 30 }} />
            <Typography className="legenda">Regulado NIR</Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="column" alignItems="center">
            <img
              src={IconeLeitoExtraCross}
              alt="Ícone Leito Extra Cross"
              style={{ width: 50, height: 30 }}
            />
            <Typography className="legenda">Leito Extra CROSS</Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="column" alignItems="center">
            <img
              src={IconeLeitoExtraNaoCross}
              alt="Ícone Leito Extra Não Cross"
              style={{ width: 30, height: 30 }}
            />
            <Typography className="legenda">Leito Extra NÃO CROSS</Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="column" alignItems="center">
            <img
              src={IconeBerco}
              alt="Ícone Leito RN"
              style={{ width: 30, height: 30 }}
            />
            <Typography className="legenda">Leito RN</Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="column" alignItems="center">
            <img
              src={IconeBercoR}
              alt="Ícone Leito RN Regulado NIR"
              style={{ width: 30, height: 30 }}
            />
            <Typography className="legenda">Leito RN Regulado NIR</Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="column" alignItems="center">
            <img
              src={IconeBercoE}
              alt="Ícone Leito RN Extra NÃO CROSS"
              style={{ width: 30, height: 30 }}
            />
            <Typography className="legenda">Leito RN Extra NÃO CROSS</Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="column" alignItems="center">
            <img
              src={IconeLeitoBloqueado}
              alt="Ícone Bloqueado"
              style={{ width: 30, height: 30 }}
            />
            <Typography className="legenda">Bloqueado</Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="column" alignItems="center">
            <img
              src={IconeBloqueadoE}
              alt="Ícone Extra NÂO CROSS"
              style={{ width: 30, height: 30 }}
            />
            <Typography className="legenda">Bloqueado Extra NÂO CROSS</Typography>
          </Grid>
        </Grid>
      </Grid>

      <FormControl fullWidth>
        <InputLabel id="unidade-tecnica">Unidade Tecnica</InputLabel>
        <Select
          labelId="unidade-tecnica"
          id="unidade-tecnica"
          value={unidadeTecnicaSelecionadaId}
          label="Unidade Tecnica"
          onChange={alteraUnidadeTecnica}
        >
          {listaUnidadeTecnica.map(unidadeTecnica => (
            <MenuItem value={unidadeTecnica.id} key={unidadeTecnica.id}>
              {unidadeTecnica.nome}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <br />
      <br />

      {listaAlas.map(ala => (
        <Accordion
          key={ala.nome}
          expanded={alaOpen === ala.nome}
          onChange={() => handleAccordionChange(ala.nome)}
          ref={refsAlas.current[ala.nome]}
          style={{
            padding: '10px',
            margin: '5px',
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} key={ala.nome}>
            <Typography>{ala.nome}</Typography>
          </AccordionSummary>
          <Grid container spacing={2} style={{ width: '100%' }}>
            {ala.quartos.map(quarto => (
              <Grid
                key={quarto.seqQuarto}
                item
                xs={quarto.leitos.length > 12 ? 12 : quarto.leitos.length}
                sm={quarto.leitos.length > 12 ? 12 : quarto.leitos.length}
              >
                <Card
                  style={{
                    backgroundColor: '#D9D9D9',
                  }}
                >
                  <CardContent
                    style={{
                      display: 'flex',
                      justifyContent: 'space-around',
                      padding: '0.9vw',
                      height: `${Math.ceil(quarto.leitos.length / 12) * 5.6}vw`,
                    }}
                  >
                    {renderQuarto(ala, quarto)}
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Accordion>
      ))}
    </>
  );
}
